/**
 * Collapses a duplicated trailing period in a translation string.
 *
 * Some translations get an extra "." appended at the call site (e.g. when a
 * sentence-cased value already ends in a period), producing "..". This trims a
 * trailing run of two or more dots down to a single ".".
 *
 * The duplicate dot may also sit outside a closing HTML tag when the tagged
 * content already ends in a period, e.g. "<b>word.</b>." renders as "word.."
 * — those closing tags are preserved and only the redundant outer dot(s) are
 * dropped, yielding "<b>word.</b>".
 *
 * @param translation - The translated string to normalize.
 * @returns The translation with any redundant trailing period collapsed.
 */
export const collapseTrailingPeriod = (translation: string): string =>
  translation.replace(/\.((?:<\/[^>]+>)*)\.+$/, ".$1");
